export { PersonDialogComponent as DialogComponent } from './components/person-dialog.component';
export { PersonFormComponent as FormComponent } from './components/person-form.component';
export { PersonMainComponent as MainComponent } from './components/person-main.component';
